module.exports = __webpack_public_path__ + "img/img23.2ada3a46.svg";